import { fetchImage } from 'lib/utils';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loadPersons, setError, setPersonsLoaded } from 'store';

const usePersonsLoad = () => {
  const dispatch = useDispatch();
  const [spritesList, setSpritesList] = useState<Record<string, any>>({});

  const loadSetting = useCallback(async () => {
    try {
      const { error, payload }: any = await dispatch(loadPersons());
      if (error) {
        return;
      }
      const namePerson: any[] = [];
      Object.keys(payload).forEach((personId) => {
        const { name, ...rest } = payload[personId];
        Object.entries(rest).forEach(([skinId, url]) => {
          namePerson.push({ personId, skinId, url });
        });
      });
      const loadSKINS = await Promise.allSettled(
        namePerson.map(({ personId, url }) => fetchImage(personId, url))
      );
      let load = true;
      let savePerson: any = {};
      loadSKINS.forEach(({ status, value }: any, ind) => {
        if (status !== 'fulfilled') {
          load = false;
          return;
        }
        const { personId, skinId } = namePerson.find((_, index) => index === ind);
        savePerson = {
          ...savePerson,
          [personId]: {
            ...savePerson[personId],
            [skinId]: value[personId],
          },
        };
      });

      dispatch(setPersonsLoaded(load));
      load && setSpritesList(savePerson);
    } catch {
      dispatch(setError());
    }
  }, []);

  useEffect(() => {
    loadSetting();
  }, [loadSetting]);

  return spritesList;
};

export default usePersonsLoad;
